var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnthinkableLoginLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0065 41.0189L14.0345 41.0539L0 4.40317L3.81189 3.96045L18.0065 41.0189Z",
    fill: "#83CB34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5016 2.73002V30.3888L30.6146 32.0221L29.3315 28.6754L16.7327 30.1387L6.59521 3.63797L31.2825 0.769043L32.5481 4.11821L44.5016 2.73002Z",
    fill: "#83CB34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnthinkableLoginLogo);
export default __webpack_public_path__ + "static/media/UnthinkableLoginLogo.d63bf7bbe203294d5b53070123360667.svg";
export { ForwardRef as ReactComponent };